import React from 'react';
import { observer } from 'mobx-react-lite';

export const MobileRoundStepInfo = observer(({ step, className = '', children }) => {
  return (
    <div className={`mob-g-area-bets-bl ${className}`}>
      <p style={step ? { opacity: 1 } : { opacity: 0 }} className='mob-g-a-b-left'>
        {step}
      </p>
      {children}
    </div>
  );
});
